<div class="modal-container  popup-general modal-sm percent_35 row">
    <div class="modal-container-header col-12">
       <span>{{ title | translate}}</span> 
      <span class="k-icon k-i-close" (click)="closeModal(false)"  *ngIf="aspa"></span>
    </div>

         
    <div class="modal-container-section col-12">
      <div class="col-12">
        <p>{{ message | translate }}</p>
      </div>
     
      <div class="modal-footer p-0">
            
        <button *ngIf="isButtonOk" type="button"
          class="btn btn-secondary  verde_con_efecto border_all" 
         (click)="closeModal(true)">
          <span class="k-icon k-i-check-circle text-size-big"></span>
          {{ textButtonOk | translate}}
        </button>
         
        <button *ngIf="isButtonCancel"  type="button"
         class="btn btn-secondary float-right  rojo_con_efecto"
          (click)="closeModal(false)">
          <span class="k-icon k-i-close-circle  text-size-big"></span>
          {{ textButtonCancel | translate}}
        </button>
        
      </div>
  
    </div>
      
  </div>